/**
 * Utility per gestire i percorsi degli assets
 * Gestisce automaticamente i percorsi per sviluppo e produzione
 */

export const getAssetPath = (path: string): string => {
  // Rimuovi la barra iniziale se presente
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;
  
  // In produzione, Vite processa gli assets e li mette nella cartella assets
  // con hash o nomi specifici. Per i video, usiamo il nome originale
  if (import.meta.env.PROD) {
    return `/assets/${cleanPath.split('/').pop()}`;
  }
  
  // In sviluppo, usa il percorso relativo dalla cartella public
  return `/${cleanPath}`;
};

// Array di tutti i video per il carousel
export const TRAVEL_VIDEOS = [
  getAssetPath('assets/videos/vid1.mp4'),
  getAssetPath('assets/videos/vid2.mp4'),
  getAssetPath('assets/videos/vid3.mp4'),
  getAssetPath('assets/videos/vid4.mp4'),
  getAssetPath('assets/videos/vid5.mp4')
] as const;
